import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import cx from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import JBImage from 'components/essentials/JBImage';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
import useScreen from 'hooks/useScreen';
import definition from './definition.yaml';
const getOptimizedImage = (url, w, h) => {
  if (!url || url.indexOf('imgix.net') === -1) {
    return url;
  }
  const params = `auto=compress,format&w=${w}&h=${h}&dpr=2&q=40&cs=srgb`;
  if (url.indexOf('?') > -1) {
    return `${url}&${params}`;
  }
  return `${url}?${params}`;
};
const BannerTextSection = t0 => {
  const $ = _c(69);
  const {
    className,
    config,
    fullWidth: t1,
    variant
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const {
    textContent: t2,
    colors: t3,
    cta,
    ctaColors: t4,
    toggleInputType,
    isCarousel: t5
  } = config;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const textContent = t6;
  let t7;
  if ($[2] !== t3) {
    t7 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const colors = t7;
  let t8;
  if ($[4] !== t4) {
    t8 = t4 === undefined ? {} : t4;
    $[4] = t4;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const ctaColors = t8;
  const isCarousel = t5 === undefined ? false : t5;
  const [iFrameVisibility, setIFrameVisibility] = useState(false);
  const {
    isMobileOrTablet: useImageExtraWide
  } = useScreen();
  const {
    backgroundImage,
    icon,
    heroFancyText,
    heroFancyTextColor,
    heroLogomark,
    body,
    title,
    disclaimer,
    iconWidth: t9
  } = textContent;
  const iconWidth = t9 === undefined ? "50%" : t9;
  let t10;
  if ($[6] !== colors) {
    t10 = get(colors, "textHex", definition.props.colors.textHex);
    $[6] = colors;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const colorsTextHex = t10;
  let t11;
  if ($[8] !== ctaColors) {
    t11 = get(ctaColors, "backgroundHex", definition.props.ctaColors.backgroundHex);
    $[8] = ctaColors;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const ctaColorsBackgroundHex = t11;
  let t12;
  if ($[10] !== ctaColors) {
    t12 = get(ctaColors, "textHex", definition.props.ctaColors.textHex);
    $[10] = ctaColors;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const ctaColorsTextHex = t12;
  let t13;
  if ($[12] !== ctaColorsBackgroundHex) {
    t13 = {
      backgroundColor: ctaColorsBackgroundHex
    };
    $[12] = ctaColorsBackgroundHex;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== ctaColorsTextHex) {
    t14 = {
      color: ctaColorsTextHex
    };
    $[14] = ctaColorsTextHex;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t13 || $[17] !== t14) {
    t15 = {
      background: t13,
      text: t14
    };
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const ctaStyles = t15;
  let t16;
  if ($[19] !== backgroundImage || $[20] !== useImageExtraWide) {
    t16 = backgroundImage ? {
      backgroundImage: `url(${getOptimizedImage(backgroundImage, useImageExtraWide ? 798 : 512, useImageExtraWide ? 358 : 531)})`
    } : {};
    $[19] = backgroundImage;
    $[20] = useImageExtraWide;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const textContentBackgroundStyles = t16;
  const t17 = `px-5 py-8 flex flex-none h-full w-full flex-col justify-center object-cover bg-cover md:px-[3.333vw] md:py-8 lg:[text-align:initial] lg:min-w-[480px] lg:px-[3.333vw] lg:py-0 lg:w-[480px] min-[1440px]:min-w-[540px] min-[1440px]:w-[540px] ${className}`;
  const t18 = variant === "ShopPagePromotionPanel";
  let t19;
  if ($[22] !== fullWidth || $[23] !== isCarousel || $[24] !== t17 || $[25] !== t18) {
    t19 = cx(t17, {
      "lg:min-w-full lg:w-full": fullWidth,
      "pl-[calc(3.333vw_+_20px)]": isCarousel,
      "!p-[55px] !w-full !min-w-full !rounded-[.5rem] md:max-[1023px]:!rounded-none": t18
    });
    $[22] = fullWidth;
    $[23] = isCarousel;
    $[24] = t17;
    $[25] = t18;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== icon || $[28] !== iconWidth) {
    t20 = icon && <img className="mb-5 w-1/2 max-w-[260px] md:max-w-[50%]" src={icon} alt="Icon" style={{
      width: iconWidth
    }} />;
    $[27] = icon;
    $[28] = iconWidth;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== heroLogomark) {
    t21 = heroLogomark && <JBImage className="mb-5" src={heroLogomark} width={400} height={200} />;
    $[30] = heroLogomark;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== heroFancyText || $[33] !== heroFancyTextColor) {
    t22 = heroFancyText && <span className="mb-5 text-[1.4rem] non-italic font-normal md:text-[1.4rem]" style={{
      color: heroFancyTextColor
    }}>{heroFancyText}</span>;
    $[32] = heroFancyText;
    $[33] = heroFancyTextColor;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== colorsTextHex) {
    t23 = {
      color: colorsTextHex
    };
    $[35] = colorsTextHex;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t23 || $[38] !== title) {
    t24 = <h1 className="text-4xl font-bold mb-3 md:mb-5" style={t23}>{title}</h1>;
    $[37] = t23;
    $[38] = title;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== body || $[41] !== colorsTextHex) {
    t25 = body && <p className="text-base font-bold mb-6 md:text-lg md:font-bold" style={{
      color: colorsTextHex
    }}>{body}</p>;
    $[40] = body;
    $[41] = colorsTextHex;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== cta || $[44] !== ctaStyles) {
    t26 = !!cta && cta.content && (!cta.embedCode || !cta.embedCode.enabled) && <div><CtaLink style={ctaStyles} to={cta.linkTo} styling={cta.style} color="brand">{cta.content}</CtaLink></div>;
    $[43] = cta;
    $[44] = ctaStyles;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== ctaStyles || $[47] !== toggleInputType) {
    t27 = !!toggleInputType && <ToggleCTALinkButton style={ctaStyles} toggleInputType={toggleInputType} />;
    $[46] = ctaStyles;
    $[47] = toggleInputType;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== cta || $[50] !== ctaStyles || $[51] !== iFrameVisibility || $[52] !== toggleInputType) {
    t28 = !toggleInputType && !!cta && cta.embedCode && cta.embedCode.enabled && <div>{iFrameVisibility ? <JBIFrameHolder isOpen={iFrameVisibility} onClose={setIFrameVisibility} script={cta.embedCode.value || ""} /> : null}<CtaButton style={ctaStyles} onClick={() => {
        setIFrameVisibility(true);
      }} color={cta.color || "brand"} styling={cta.style || "solid-button"}>{cta.content}</CtaButton></div>;
    $[49] = cta;
    $[50] = ctaStyles;
    $[51] = iFrameVisibility;
    $[52] = toggleInputType;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== colorsTextHex || $[55] !== disclaimer) {
    t29 = disclaimer && <p className="mt-4 mb-0 opacity-75 md:mt-6 text-xs font-bold" style={{
      color: colorsTextHex
    }}>{disclaimer}</p>;
    $[54] = colorsTextHex;
    $[55] = disclaimer;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t19 || $[58] !== t20 || $[59] !== t21 || $[60] !== t22 || $[61] !== t24 || $[62] !== t25 || $[63] !== t26 || $[64] !== t27 || $[65] !== t28 || $[66] !== t29 || $[67] !== textContentBackgroundStyles) {
    t30 = <div className={t19} style={textContentBackgroundStyles}>{t20}{t21}{t22}{t24}{t25}{t26}{t27}{t28}{t29}</div>;
    $[57] = t19;
    $[58] = t20;
    $[59] = t21;
    $[60] = t22;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
    $[66] = t29;
    $[67] = textContentBackgroundStyles;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  return t30;
};
BannerTextSection.propTypes = {
  config: PropTypes.shape({
    colors: PropTypes.shape({
      textHex: PropTypes.string
    }),
    cta: PropTypes.shape({
      color: PropTypes.string,
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string
      }),
      linkTo: PropTypes.string,
      style: PropTypes.string
    }),
    ctaColors: PropTypes.shape({
      backgroundHex: PropTypes.string,
      textHex: PropTypes.string
    }),
    isCarousel: PropTypes.bool,
    textContent: PropTypes.shape({
      backgroundImage: PropTypes.string,
      body: PropTypes.string,
      disclaimer: PropTypes.string,
      heroFancyText: PropTypes.string,
      heroFancyTextColor: PropTypes.string,
      icon: PropTypes.string,
      iconWidth: PropTypes.string,
      title: PropTypes.string
    }),
    toggleInputType: PropTypes.object
  }),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['ShopPagePromotionPanel'])
};
export default BannerTextSection;